var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-check"},[_c('b-form-checkbox',{on:{"change":function($event){return _vm.updateStatus()}},model:{value:(_vm.form.authorized),callback:function ($$v) {_vm.$set(_vm.form, "authorized", $$v)},expression:"form.authorized"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }